import React, { useContext } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { setIsFirstTime } from "store/actions";
import { forbidExtraProps } from "utils";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { LayoutContext } from "App/common/hoc/Layout";

function NavItem(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const path =
    (props.expiryDays < 1 &&
      props.plan &&
      props.plan.planType !== "Paid" &&
      props.ecommerceFlag !== "S" &&
      props.ecommerceFlag !== "O" &&
      props.ecommerceFlag !== "Y") ||
    props.applyPendingChargesFlag
      ? "/mirror/account/planOptions"
      : props.page.path;
  return (
    <li className={"li_icon " + props.page.iconClass}>
      <Tooltip
        {...(lState.sidebarCollapse ? TOOLTIPS.layout[props.page.key] : {})}
      >
        <NavLink
          to={path}
          activeClassName={
            props.isFirst && props.page.key === "dashboard"
              ? "inactive"
              : props.expiryDays < 1 &&
                props.plan &&
                props.plan.planType !== "Paid" &&
                props.ecommerceFlag !== "S" &&
                props.ecommerceFlag !== "O" &&
                props.ecommerceFlag !== "Y"
              ? "inactive"
              : "active"
          }
          onClick={() => {
            if (window.innerWidth <= 1024) lMethods.toggleSidebar();
            if (props.isFirst) props.setIsFirstTime();
          }}
        >
          <span className="lhs_icon"></span>
          <span className="lhs_text">{props.page.name}</span>
          {props.page.newTag && <i class="newTag">New</i>}
        </NavLink>
      </Tooltip>
    </li>
  );
}

NavItem.propTypes = forbidExtraProps(
  {
    page: PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string
    })
  },
  ["isFirst"]
);

function mapStateToProps(state) {
  return {
    expiryDays: state.account.expiryDays,
    ecommerceFlag: state.account.ecommerceFlag,
    plan: state.account.plan,
    applyPendingChargesFlag: state.account.applyPendingChargesFlag
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setIsFirstTime
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NavItem);
